var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.submission != null)?_c('div',{staticClass:"TemplatePdf"},[(_vm.pdfContent != null)?_c('iframe',{attrs:{"src":_vm.pdfContent,"width":"100%","height":"100%"}}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }